// One place for the booking price, so the dual-pricing popup, checkout and
// the confirmation page show what is actually charged. Mirrors the merchant
// portal's PaymentModal: the card fee is the shop's cardFeePercentage of
// (subtotal + tax), only when dual pricing is on and the customer pays by
// card. All amounts are integer cents.
export interface BookingTotals {
  taxCents: number;
  cardFeeCents: number;
  cardFeePercentage: number;
  totalCents: number;
}

export const calculateBookingTotals = ({
  subtotalCents,
  taxPercentage,
  account,
  payByCash,
  tipsCents = 0,
}: {
  subtotalCents: number;
  taxPercentage?: number | string | null;
  account?: {
    dualPricingEnabled?: boolean | null;
    cardFeePercentage?: number | string | null;
    applyTaxToService?: boolean | null;
  } | null;
  payByCash: boolean;
  tipsCents?: number;
}): BookingTotals => {
  // Bookings are services only, so tax follows the shop's "Apply Tax to
  // Services" setting - the same rule the portal's checkout uses.
  const taxRate = account?.applyTaxToService ? Number(taxPercentage) || 0 : 0;
  const taxCents = Math.round((subtotalCents * taxRate) / 100);
  const cardFeePercentage =
    account?.dualPricingEnabled && !payByCash ? Number(account?.cardFeePercentage) || 0 : 0;
  const cardFeeCents = Math.round(((subtotalCents + taxCents) * cardFeePercentage) / 100);

  return {
    taxCents,
    cardFeeCents,
    cardFeePercentage,
    totalCents: subtotalCents + taxCents + cardFeeCents + tipsCents,
  };
};
